export const LAST_ACTION_TEXTS: Record<number, string> = {
  [-1]: 'Kontoudtog sendt',
  1: 'Venlig påmindelse sendt',
  2: 'Påmindelse sendt',
  3: 'Inkassovarsel sendt',
  4: 'Sendt til inkasso',
};

export const NEXT_ACTION_TEXTS: Record<number, string> = {
  2: 'Påmindelse sendes',
  3: 'Inkassovarsel sendes',
  4: 'Sendes til inkasso',
  5: 'Sendes til inkasso',
};
